'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _DragItem = require('./DragItem');

var _DragItem2 = _interopRequireDefault(_DragItem);

var _BlankItem = require('./BlankItem');

var _BlankItem2 = _interopRequireDefault(_BlankItem);

var _FlyingItem = require('./FlyingItem');

var _FlyingItem2 = _interopRequireDefault(_FlyingItem);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Created by corupta on 20/07/17.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */
/* eslint-env browser */


var dragData = {
  item: null,
  itemDimensions: {
    width: 42,
    height: 42
  },
  dragName: '',
  mySpecs: {
    height: 42,
    marginTop: 42,
    marginBottom: 42
  },
  relativeX: 42,
  relativeY: 42,
  target: null,
  isTouchOrMouse: false, //touch for true, mouse for false
  ePos: {
    x: 42,
    y: 42
  },
  currList: 42,
  isInList: false,
  upState: null
};

var defaultScrollStep = 24;

var scrollBugFix = true;

var DragList = function (_React$Component) {
  _inherits(DragList, _React$Component);

  function DragList(props) {
    _classCallCheck(this, DragList);

    var _this = _possibleConstructorReturn(this, (DragList.__proto__ || Object.getPrototypeOf(DragList)).call(this, props));

    _this.state = {
      flying: null,
      currX: -1,
      currY: -1
    };
    _this.initVariables();
    _this.initializeBindings();
    return _this;
  }

  _createClass(DragList, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      if (scrollBugFix) {
        scrollBugFix = false;
        // fixes ios chrome not scrolling initally bug !!! --WEIRD!!!
        setTimeout(function () {
          window.scrollTo(0, 1);window.scrollTo(0, 0);
        }, 4);
      }
    }
  }, {
    key: 'componentWillMount',
    value: function componentWillMount() {
      this.componentWillReceiveProps(this.props);
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      this.itemHeights = [];
      this.itemMarginTops = [];
      this.itemMarginBottoms = [];
      this.scrollDetails.step = Math.round(defaultScrollStep * (nextProps.scrollSpeed === 'undefined' ? 1.00 : nextProps.scrollSpeed));
      this.clone = typeof nextProps.removeItem === 'undefined';
    }
  }, {
    key: 'getListProps',
    value: function getListProps() {
      var ans = { ref: this.addEvents };
      ans.style = typeof this.props.style !== 'undefined' ? _extends({}, this.props.style) : {};
      ans.style.display = 'flex';
      ans.style.flexDirection = 'column';
      ans.style.height = '100%';
      ans.style.width = '100%';
      return ans;
    }
  }, {
    key: 'setHeight',
    value: function setHeight(id, stl) {
      this.itemHeights[id] = parseFloat(stl.height, 10) + parseFloat(stl.borderBottom, 10) + parseFloat(stl.borderTop, 10) + parseFloat(stl.paddingTop, 10) + parseFloat(stl.paddingBottom, 10);
      this.itemMarginTops[id] = parseFloat(stl.marginTop, 10);
      this.itemMarginBottoms[id] = parseFloat(stl.marginBottom, 10);
    }
  }, {
    key: 'initVariables',
    value: function initVariables() {
      this.blank = null;
      this.blankHeight = 42;
      this.blocker = -1;
      this.itemHeights = [];
      this.itemMarginTops = [];
      this.itemMarginBottoms = [];
      this.blankH = -1;
      this.draggedId = -1;
      this.transitionDuration = this.props.animationDuration;
      this.downNo = 0;
      this.initalElem = null;
      this.blankHeightTmp = -1;
      this.scrollDetails = {
        step: -1,
        time: 32
      };
    }
  }, {
    key: 'initializeBindings',
    value: function initializeBindings() {
      this.setHeight = this.setHeight.bind(this);
      this.getListProps = this.getListProps.bind(this);
      this.changeBlank = this.changeBlank.bind(this);
      this.handleEnterList = this.handleEnterList.bind(this);
      this.handleEnterItem = this.handleEnterItem.bind(this);
      this.handleLeaveList = this.handleLeaveList.bind(this);
      this.removeFlying = this.removeFlying.bind(this);
      this.removeFlyingHax = this.removeFlyingHax.bind(this);
      this.removeFlyingDoubleHax = this.removeFlyingDoubleHax.bind(this);
      this.removeFlyingTripleHax = this.removeFlyingTripleHax.bind(this);
      this.maybeScrollPage = this.maybeScrollPage.bind(this);
      this.maybeScrollList = this.maybeScrollList.bind(this);
      this.startScrollInterval = this.startScrollInterval.bind(this);
      this.moveFlying = this.moveFlying.bind(this);
      this.moveFlyingBody = this.moveFlyingBody.bind(this);
      this.moveFlyingScrollList = this.moveFlyingScrollList.bind(this);
      this.moveFlyingList = this.moveFlyingList.bind(this);
      this.moveFlyingBodyHax = this.moveFlyingBodyHax.bind(this);
      this.moveFlyingBodyDoubleHax = this.moveFlyingBodyDoubleHax.bind(this);
      this.maxOutTransitionDuration = this.maxOutTransitionDuration.bind(this);
      this.handleStartEvents = this.handleStartEvents.bind(this);
      this.calculateBlankHeight = this.calculateBlankHeight.bind(this);
      this.fixBlankHeight = this.fixBlankHeight.bind(this);
      this.calculateBlankH = this.calculateBlankH.bind(this);
      this.handleStartContinue = this.handleStartContinue.bind(this);
      this.handleStart = this.handleStart.bind(this);
      this.dropCallback = this.dropCallback.bind(this);
      this.drop = this.drop.bind(this);
      this.addEvents = this.addEvents.bind(this);
      this.setState = this.setState.bind(this);
    }
  }, {
    key: 'changeBlank',
    value: function changeBlank(id) {
      this.maxOutTransitionDuration();
      this.blocker = id;
      this.blankHeight = this.calculateBlankHeight(this.draggedId === id - 1 ? id - 2 : id - 1, id);
      this.blankH = this.calculateBlankH(id);
      this.setState({});
    }
  }, {
    key: 'handleEnterList',
    value: function handleEnterList() {
      if (dragData.item !== null && dragData.dragName === this.props.dropName) {
        if (this.blocker === -1) {
          if (this.blank === null) {
            this.blank = typeof this.props.dropFunc === 'undefined' ? dragData.item : this.props.dropFunc(dragData.item, this.props.myGid);
          }
          this.changeBlank(typeof this.props.children === 'undefined' ? 0 : this.props.children.length);
        }
      }
    }
  }, {
    key: 'handleEnterItem',
    value: function handleEnterItem(id) {
      if (dragData.item !== null && dragData.dragName === this.props.dropName) {
        var newId = id;
        if (this.blocker <= newId) {
          ++newId;
        }
        if (this.blocker !== newId) {
          if (this.blank === null) {
            this.blank = typeof this.props.dropFunc === 'undefined' ? dragData.item : this.props.dropFunc(dragData.item, this.props.myGid);
          }
          this.changeBlank(newId);
        }
      }
    }
  }, {
    key: 'handleLeaveList',
    value: function handleLeaveList() {
      if (dragData.item !== null && dragData.dragName === this.props.dropName) {
        if (this.blank !== null) {
          this.blank = null;
          this.blocker = -1;
          this.blankH = -1;
          this.blankHeightTmp = -1;
          this.setState({});
        }
      }
    }
  }, {
    key: 'removeFlying',
    value: function removeFlying() {
      this.draggedId = -1;
      window.removeEventListener('supermove', this.moveFlyingBody);
      window.removeEventListener('superend', this.removeFlying);
      if (window.PointerEvent) {
        window.removeEventListener('pointerup', this.removeFlyingHax);
        window.removeEventListener('pointermove', this.moveFlyingBodyHax);
      } else {
        window.removeEventListener('mouseup', this.removeFlyingHax);
        window.removeEventListener('touchend', this.removeFlyingHax);
        window.removeEventListener('mousemove', this.moveFlyingBodyHax);
        window.removeEventListener('touchmove', this.moveFlyingBodyHax);
      }
      dragData = {
        item: null,
        dragName: '',
        blankHeight: -1,
        scrollPage: {
          left: false,
          up: false,
          right: false,
          down: false
        }
      };
      if (this.state.flying !== null) {
        this.setState({
          flying: null,
          currX: -1,
          currY: -1
        });
      }
    }
  }, {
    key: 'removeFlyingHax',
    value: function removeFlyingHax(e) {
      if (dragData.isTouchOrMouse || e.button === 0) {
        e.preventDefault();
        e.stopPropagation();
        if (document.elementFromPoint(dragData.ePos.x, dragData.ePos.y) === null) {
          this.removeFlying();
        } else {
          document.elementFromPoint(dragData.ePos.x, dragData.ePos.y).dispatchEvent(new Event('superend', { bubbles: true }));
        }
      }
    }
  }, {
    key: 'removeFlyingDoubleHax',
    value: function removeFlyingDoubleHax() {
      ++this.downNo;
      this.initalElem.removeEventListener('overMeh', this.handleOverInitial);
      window.removeEventListener('overMeh', this.removeFlyingDoubleHax);
      if (window.PointerEvent) {
        window.removeEventListener('pointermove', this.moveFlyingBodyDoubleHax);
        window.removeEventListener('pointerup', this.removeFlyingTripleHax);
      } else {
        window.removeEventListener('touchmove', this.moveFlyingBodyDoubleHax);
        window.removeEventListener('mousemove', this.moveFlyingBodyDoubleHax);
        window.removeEventListener('touchup', this.removeFlyingTripleHax);
        window.removeEventListener('mouseup', this.removeFlyingTripleHax);
      }
    }
  }, {
    key: 'removeFlyingTripleHax',
    value: function removeFlyingTripleHax(e) {
      if (dragData.isTouchOrMouse || e.button === 0) {
        this.removeFlyingDoubleHax();
      }
    }
  }, {
    key: 'maybeScrollPage',
    value: function maybeScrollPage() {
      var currX = Math.round(window.scrollX || window.pageXOffset);
      var currY = Math.round(window.scrollY || window.pageYOffset);
      var pageH = Math.max(document.body.scrollHeight, document.documentElement.scrollHeight) - window.innerHeight;
      var pageW = Math.max(document.body.scrollWidth, document.documentElement.scrollWidth) - window.innerWidth;
      if (dragData.ePos.x - this.props.scrollWhen < 0) {
        window.scrollTo(Math.max(0, currX - this.scrollDetails.step), currY);
      }
      if (dragData.ePos.y - this.props.scrollWhen < 0) {
        window.scrollTo(currX, Math.max(0, currY - this.scrollDetails.step));
      }
      if (dragData.ePos.x + this.props.scrollWhen > window.innerWidth) {
        window.scrollTo(Math.min(pageW, currX + this.scrollDetails.step), currY);
      }
      if (dragData.ePos.y + this.props.scrollWhen > window.innerHeight) {
        window.scrollTo(currX, Math.min(pageH, this.scrollDetails.step + currY));
      }
    }
  }, {
    key: 'maybeScrollList',
    value: function maybeScrollList() {
      var getRect = this.me.getBoundingClientRect();
      var realStl = {
        left: getRect.left - this.leftMargin,
        top: getRect.top - this.topMargin,
        right: getRect.right - this.rightMargin,
        bottom: getRect.bottom - this.bottomMargin
      };
      if (dragData.ePos.x - this.props.scrollWhen < realStl.left) {
        this.me.scrollLeft = Math.max(0, this.me.scrollLeft - this.scrollDetails.step);
      }
      if (dragData.ePos.y - this.props.scrollWhen < realStl.top) {
        this.me.scrollTop = Math.max(0, this.me.scrollTop - this.scrollDetails.step);
      }
      if (dragData.ePos.x + this.props.scrollWhen > realStl.right) {
        this.me.scrollLeft = Math.min(this.me.scrollWidth, this.me.scrollLeft + this.scrollDetails.step);
      }
      if (dragData.ePos.y + this.props.scrollWhen > realStl.bottom) {
        this.me.scrollTop = Math.min(this.me.scrollHeight, this.me.scrollTop + this.scrollDetails.step);
      }
    }
  }, {
    key: 'startScrollInterval',
    value: function startScrollInterval() {
      if (dragData.item !== null) {
        if (dragData.scrollListCallback !== null) {
          dragData.scrollListCallback();
        }
        this.maybeScrollPage();
        dragData.upState({
          currX: (this.props.lockX ? 0 : dragData.ePos.x) + dragData.relativeX,
          currY: dragData.ePos.y + dragData.relativeY
        });
        setTimeout(this.startScrollInterval, this.scrollDetails.time);
      }
    }
  }, {
    key: 'moveFlying',
    value: function moveFlying(item, listScrollCallback, newListId, newId, offset) {
      if (item === null || dragData.isInList === false || dragData.currList !== newListId) {
        if (dragData.isInList) {
          dragData.target.dispatchEvent(new Event('leaveMeh', { bubbles: true }));
        }
        dragData.currList = newListId;
        dragData.isInList = true;
        dragData.scrollListCallback = listScrollCallback;
        if (item === null) {
          dragData.isInList = false;
        }
      }
      //if (dragData.target !== item) {
      if (newId === -1) {
        dragData.target = item;
        if (dragData.target !== null) {
          dragData.target.dispatchEvent(new Event('enterMeh', { bubbles: true }));
        }
      } else if (newId < this.blocker) {
        if (dragData.ePos.y < offset.top * 3 / 10 + offset.bottom * 7 / 10) {
          dragData.target = item;
          dragData.target.dispatchEvent(new Event('enterMeh', { bubbles: true }));
        }
      } else if (newId >= this.blocker) {
        if (dragData.ePos.y > offset.top * 7 / 10 + offset.bottom * 3 / 10) {
          dragData.target = item;
          dragData.target.dispatchEvent(new Event('enterMeh', { bubbles: true }));
        }
      }
      //}
    }
  }, {
    key: 'moveFlyingBody',
    value: function moveFlyingBody() {
      this.moveFlying(null, null, -1, -1, {});
    }
  }, {
    key: 'moveFlyingScrollList',
    value: function moveFlyingScrollList(elem, myId, offset) {
      this.moveFlying(elem, this.maybeScrollList, this.props.myGid, myId, offset);
    }
  }, {
    key: 'moveFlyingList',
    value: function moveFlyingList(e) {
      this.moveFlyingScrollList(this.me, -1, {});
      e.stopPropagation();
    }
  }, {
    key: 'moveFlyingBodyHax',
    value: function moveFlyingBodyHax(e) {
      if (dragData.item !== null) {
        if (dragData.isTouchOrMouse) {
          if (this.props.lockX === false) {
            dragData.ePos.x = e.touches.item(0).clientX;
          }
          dragData.ePos.y = e.touches.item(0).clientY;
        } else {
          if (this.props.lockX === false) {
            dragData.ePos.x = e.clientX;
          }
          dragData.ePos.y = e.clientY;
        }
        e.preventDefault();
        e.stopPropagation();
        if (document.elementFromPoint(dragData.ePos.x, dragData.ePos.y) === null) {
          this.moveFlyingBody();
        } else {
          document.elementFromPoint(dragData.ePos.x, dragData.ePos.y).dispatchEvent(new Event('supermove', { bubbles: true }));
        }
      }
    }
  }, {
    key: 'moveFlyingBodyDoubleHax',
    value: function moveFlyingBodyDoubleHax(e) {
      dragData.ePos = dragData.isTouchOrMouse ? { x: e.touches.item(0).clientX, y: e.touches.item(0).clientY } : { x: e.clientX, y: e.clientY };
      var elem = document.elementFromPoint(dragData.ePos.x, dragData.ePos.y);
      if (elem === null) {
        this.removeFlyingDoubleHax();
      } else {
        elem.dispatchEvent(new Event('overMeh', { bubbles: true }));
      }
    }
  }, {
    key: 'maxOutTransitionDuration',
    value: function maxOutTransitionDuration() {
      this.transitionDuration = this.props.animationDuration;
    }
  }, {
    key: 'handleStartEvents',
    value: function handleStartEvents() {
      window.addEventListener('supermove', this.moveFlyingBody);
      window.addEventListener('superend', this.removeFlying);
      if (window.PointerEvent) {
        window.removeEventListener('pointerup', this.removeFlyingTripleHax);
        window.addEventListener('pointerup', this.removeFlyingHax);
        window.removeEventListener('pointermove', this.moveFlyingBodyDoubleHax);
        window.addEventListener('pointermove', this.moveFlyingBodyHax);
      } else {
        window.removeEventListener('mouseup', this.removeFlyingTripleHax);
        window.removeEventListener('touchend', this.removeFlyingTripleHax);
        window.addEventListener('mouseup', this.removeFlyingHax);
        window.addEventListener('touchend', this.removeFlyingHax);
        window.removeEventListener('mousemove', this.moveFlyingBodyDoubleHax);
        window.removeEventListener('touchmove', this.moveFlyingBodyDoubleHax);
        window.addEventListener('mousemove', this.moveFlyingBodyHax);
        window.addEventListener('touchmove', this.moveFlyingBodyHax);
      }
    }
  }, {
    key: 'calculateBlankH',
    value: function calculateBlankH(id) {
      if (typeof this.props.children === 'undefined' || id === this.props.children.length) {
        return 0;
      }
      var prevId = this.props.children.length - 1;
      if (prevId === this.draggedId) {
        --prevId;
      }
      //let ans = -Math.max((prevId < 0 ? 0 : this.itemMarginBottoms[prevId]), dragData.mySpecs.marginTop);
      var ans = 0;
      //console.log('lele');
      for (var i = id; i < this.props.children.length; ++i) {
        if (i !== this.draggedId) {
          ans -= this.itemHeights[i] + this.itemMarginBottoms[i] + this.itemMarginTops[i];
          /*let prevI = i - 1;
          if (prevI === this.draggedId) {
            --prevI;
          }*/
          //ans -= Math.max((prevI < 0 ? 0 : this.itemMarginBottoms[prevI]), this.itemMarginTops[i]);
          //console.log(i);
          //console.log(this.itemHeights[i]);
          //console.log(this.itemMarginBottoms[i]);
          //console.log(this.itemMarginTops[i]);
        }
      }
      //console.log('bebe');
      prevId = id - 1;
      if (prevId === this.draggedId) {
        --prevId;
      }
      //console.log(ans);
      //ans += Math.max((prevId < 0 ? 0 : this.itemMarginBottoms[prevId]), dragData.mySpecs.marginTop);
      return ans;
    }
  }, {
    key: 'fixBlankHeight',
    value: function fixBlankHeight(di) {
      if (this.blankHeightTmp === -1) {
        var stl = window.getComputedStyle(di, null);
        //console.log('fbh');
        //console.log(dragData.mySpecs);
        dragData.mySpecs = {
          height: parseFloat(stl.height, 10) + parseFloat(stl.borderTop, 10) + parseFloat(stl.borderBottom, 10) + parseFloat(stl.paddingTop, 10) + parseFloat(stl.paddingBottom, 10),
          marginTop: parseFloat(stl.marginTop, 10),
          marginBottom: parseFloat(stl.marginBottom, 10)
        };
        //console.log(dragData.mySpecs);
        //console.log(this.blankH);
        //console.log(this.blankHeight);
        this.blankH = this.calculateBlankH(this.blocker);
        this.blankHeight = this.calculateBlankHeight(this.blocker - 1 === this.draggedId ? this.blocker - 2 : this.blocker - 1, this.blocker);
        //console.log(this.blankH);
        //console.log(this.blankHeight);
        this.setState({});
        this.blankHeightTmp = 0;
      }
    }
  }, {
    key: 'calculateBlankHeight',
    value: function calculateBlankHeight(prevId, nextId) {
      if (typeof this.props.children === 'undefined') {
        return 0;
      }
      /*
      let ans = dragData.mySpecs.height;
      ans -= Math.max((prevId >= 0 ? this.itemMarginBottoms[prevId] : 0), (nextId < this.props.children.length ? this.itemMarginTops[nextId] : 0));
      ans += Math.max(dragData.mySpecs.marginTop, (prevId >= 0 ? this.itemMarginBottoms[prevId] : 0));
      ans += Math.max(dragData.mySpecs.marginBottom, (nextId < this.props.children.length ? this.itemMarginTops[nextId] : 0));
      return ans;
      */
      return dragData.mySpecs.height + dragData.mySpecs.marginTop + dragData.mySpecs.marginBottom;
    }
  }, {
    key: 'handleStartContinue',
    value: function handleStartContinue(id, stl, downNo, elemDimensions, getFocusLocker) {
      var _this2 = this;

      if (getFocusLocker() === 0 && downNo === this.downNo) {
        dragData.currList = this.props.myGid;
        dragData.isInList = true;
        dragData.target = this.me;
        dragData.dropCallback = this.dropCallback;
        dragData.dragName = this.props.dragName;
        dragData.item = this.props.children[id];
        dragData.itemDimensions = elemDimensions;
        dragData.mySpecs = {
          height: this.itemHeights[id],
          marginTop: this.itemMarginTops[id],
          marginBottom: this.itemMarginBottoms[id]
        };
        dragData.scrollListCallback = this.maybeScrollList;
        dragData.upState = this.setState;
        this.handleStartEvents();
        if (this.props.lockX) {
          dragData.ePos.x = this.middle;
        }
        if (this.props.dragName === this.props.dropName) {
          this.blank = typeof this.props.dropFunc === 'undefined' ? dragData.item : this.props.dropFunc(dragData.item, this.props.myGid);
          this.blocker = id + (this.clone === true ? 0 : 1);
          this.blankHeight = this.calculateBlankHeight(id - 1, this.blocker);
          this.blankHeightTmp = 0;
          this.draggedId = this.clone === true ? -1 : id;
          this.blankH = this.calculateBlankH(this.blocker);
          if (this.clone === false) {
            this.transitionDuration = 0;
            setTimeout(this.maxOutTransitionDuration, 4);
          } else {
            this.maxOutTransitionDuration();
          }
        } else if (this.clone === false) {
          this.draggedId = id;
          this.blocker = id;
          this.transitionDuration = 0;
          this.blankHeight = this.calculateBlankHeight(id - 1, id + 1);
          this.setState({}, function () {
            setTimeout(function () {
              _this2.maxOutTransitionDuration();_this2.blankHeight = 0;_this2.blocker = -1;_this2.setState({});
            }, 8);
          });
        }
        this.setState({
          flying: this.props.children[id],
          currX: stl.left,
          currY: stl.top
        });
        this.startScrollInterval();
      }
    }
  }, {
    key: 'handleOverInitial',
    value: function handleOverInitial(e) {
      e.stopPropagation();
    }
  }, {
    key: 'handleStart',
    value: function handleStart(id, stl, tOm, e, elem, elemDimensions, getFocusLocker) {
      if (this.props.dragName !== '') {
        this.initalElem = elem;
        var downNo = ++this.downNo;
        dragData.isTouchOrMouse = tOm;
        elem.addEventListener('overMeh', this.handleOverInitial);
        window.addEventListener('overMeh', this.removeFlyingDoubleHax);
        if (window.PointerEvent) {
          window.addEventListener('pointermove', this.moveFlyingBodyDoubleHax);
          window.addEventListener('pointerup', this.removeFlyingTripleHax);
        } else {
          window.addEventListener('mousemove', this.moveFlyingBodyDoubleHax);
          window.addEventListener('touchmove', this.moveFlyingBodyDoubleHax);
          window.addEventListener('mouseup', this.removeFlyingTripleHax);
          window.addEventListener('touchend', this.removeFlyingTripleHax);
        }
        this.moveFlyingBodyDoubleHax(e);
        if (tOm) {
          setTimeout(this.handleStartContinue, this.props.delayOnTouch, id, stl, downNo, elemDimensions, getFocusLocker);
        } else {
          setTimeout(this.handleStartContinue, this.props.delayOnMouse, id, stl, downNo, elemDimensions, getFocusLocker);
        }
      }
    }
  }, {
    key: 'dropCallback',
    value: function dropCallback(upMe, insertCallback, item, myGid, myId) {
      if (this.draggedId !== -1) {
        this.props.removeItem(this.props.myGid, this.draggedId, function () {
          if (typeof insertCallback !== 'undefined') {
            insertCallback(item, myGid, myId);
          }
        });
      } else if (typeof insertCallback !== 'undefined') {
        insertCallback(item, myGid, myId);
      } else {
        upMe({});
      }
      this.draggedId = -1;
    }
  }, {
    key: 'drop',
    value: function drop() {
      if (this.blank !== null) {
        var item = this.blank;
        var id = this.blocker - (this.draggedId !== -1 && this.draggedId < this.blocker ? 1 : 0);
        this.blank = null;
        this.blocker = -1;
        this.blankH = -1;
        this.blankHeightTmp = -1;
        this.transitionDuration = 0;
        dragData.dropCallback(this.setState, this.props.insertItem, item, this.props.myGid, id);
      }
    }
  }, {
    key: 'addEvents',
    value: function addEvents(di) {
      if (di !== null) {
        this.me = di;
        var stl = window.getComputedStyle(di, null);
        this.leftMargin = parseInt(stl.marginLeft, 10);
        this.topMargin = parseInt(stl.marginTop, 10);
        this.rightMargin = parseInt(stl.marginLeft, 10);
        this.bottomMargin = parseInt(stl.marginTop, 10);
        var rect = di.getBoundingClientRect();
        this.middle = rect.left / 2 + rect.right / 2;
        di.addEventListener('leaveMeh', this.handleLeaveList);
        di.addEventListener('enterMeh', this.handleEnterList);
        di.addEventListener('supermove', this.moveFlyingList);
        di.addEventListener('superend', this.drop);
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      return _react2.default.createElement('div', this.getListProps(), this.props.topElem !== null && this.props.topElem, typeof this.props.children !== 'undefined' && this.props.children.map(function (item, i) {
        return typeof item !== 'undefined' && _react2.default.createElement(
          _DragItem2.default,
          {
            setHeight: _this3.setHeight,
            trans: { H: _this3.blocker !== -1 && i >= _this3.blocker ? _this3.blankHeight : 0, dur: _this3.transitionDuration },
            key: i,
            setRelatives: function setRelatives(stl, rel) {
              if (_this3.props.lockX) {
                dragData.relativeX = stl.left;
              } else {
                dragData.relativeX = rel.left;
              }dragData.relativeY = rel.top;
            },
            onSthDown: _this3.handleStart,
            onSthEnter: _this3.handleEnterItem,
            onsupermove: _this3.moveFlyingScrollList,
            myId: i,
            myGid: _this3.props.myId,
            destroyer: _this3.draggedId === i,
            'class': _this3.props.itemClass
          },
          item
        );
      }), this.blank !== null && _react2.default.createElement(
        _BlankItem2.default,
        {
          trans: this.blankH,
          fixH: this.fixBlankHeight,
          'class': this.props.itemClass
        },
        this.blank
      ), this.state.flying !== null && _react2.default.createElement(
        _FlyingItem2.default,
        {
          left: this.state.currX,
          top: this.state.currY,
          elemDimensions: dragData.itemDimensions,
          rotate: this.props.rotateFlying,
          'class': this.props.itemClass
        },
        this.state.flying
      ), this.props.bottomElem !== null && this.props.bottomElem);
    }
  }]);

  return DragList;
}(_react2.default.Component);

exports.default = DragList;


DragList.PropTypes = {
  myGid: _propTypes2.default.number.isRequired,
  dragName: _propTypes2.default.string,
  dropName: _propTypes2.default.string,
  removeItem: _propTypes2.default.func,
  insertItem: _propTypes2.default.func,
  dropFunc: _propTypes2.default.func,
  style: _propTypes2.default.shape(),
  animationDuration: _propTypes2.default.func,
  itemClass: _propTypes2.default.string,
  topElem: _propTypes2.default.element,
  bottomElem: _propTypes2.default.element,
  scrollWhen: _propTypes2.default.number,
  scrollSpeed: _propTypes2.default.number,
  delayOnTouch: _propTypes2.default.number,
  delayOnMouse: _propTypes2.default.number,
  rotateFlying: _propTypes2.default.bool,
  lockX: _propTypes2.default.bool
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/drag-drop-list-react/dist/DragList.js
// module id = 182
// module chunks = 0